import { createStore } from '@stencil/store';

const initialState = {
  conditionTierSelection: '',
  formSubmitted: false,
  isDescriptionOpen: false,
  isConditionPerfect: true,
  leadFormUrl: '',
  optimizelyConditionTierSelectionIsActive: false,
  showConditionTierAlert: false,
  showModal: false,
  currentTab: 'ico_condition_ext',
};

const { on, onChange, state, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset };
export default state;
